import { createAction, props } from '@ngrx/store';
import { PermPostOfferLegacyModalActionPayload } from '../models/perm-post-offer-legacy-modal-action-payload.model';
import { PermPostOfferModalActionPayload } from '../models/perm-post-offer-modal-action-payload.model';
import { PermPostOfferUpdateOfferPayload } from '../models/perm-post-offer-update-offer-payload.model';

export const openLegacyPermOfferModal = createAction(
    '[AmSubmittalDetailsGridComponent] Open Legacy Perm Offer Modal',
    props<PermPostOfferLegacyModalActionPayload>()
);

export const openPermOfferModal = createAction(
    '[Submittal Statuses Dropdown Component] Open Perm Offer Modal',
    props<PermPostOfferModalActionPayload>()
);

export const openPermOfferModalFromGrid = createAction(
    '[AmSubmittalDetailsGridComponent] Open Perm Offer Modal',
    props<PermPostOfferModalActionPayload>()
);

export const openPlacedPermOfferModal = createAction(
    '[Submittal Statuses Dropdown Component] Open Placed Perm Offer Modal',
    props<PermPostOfferModalActionPayload>()
);

export const cancelPostOfferModal = createAction(
    '[Perm Offer Modal Component] Cancel Post Offer Modal'
);

export const updateOfferInfoAndSubmittalStatus = createAction(
    '[Perm Offer Modal Component] Update Offer Info and Submittal Status',
    props<PermPostOfferUpdateOfferPayload>()
);
